import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// 요청마다 JWT 토큰 자동 첨부
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 401 응답 시 자동 로그아웃
// 단, 로그인 시도 자체의 401(비밀번호 틀림)은 제외 — 강제 이동하면 에러 메시지가 바로 사라짐
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = error.config?.url || '';
    if (error.response?.status === 401 && !requestUrl.includes('/auth/login')) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);


// ─── Auth ───────────────────────────────────────────────────
export const authAPI = {
  register: (data) => api.post('/auth/register', data),
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
  findId: (nickname) => api.post('/auth/find-id', { nickname }),
  forgotPassword: (email) => api.post('/auth/forgot-password', { email }),
  resetPassword: (token, password) => api.post('/auth/reset-password', { token, password }),
};

// ─── Alertbox ───────────────────────────────────────────────
export const alertboxAPI = {
  register: (alertbox_url) => api.post('/alertbox/register', { alertbox_url }),
  status: () => api.get('/alertbox/status'),
  disconnect: () => api.post('/alertbox/disconnect'),
};

// ─── Funnation ──────────────────────────────────────────────
export const funnationAPI = {
  register: (funnation_creator_id) => api.post('/alertbox/funnation/register', { funnation_creator_id }),
  disconnect: () => api.post('/alertbox/funnation/disconnect'),
};

// ─── Ranking ────────────────────────────────────────────────
export const rankingAPI = {
  list: (params) => api.get('/ranking', { params }),
  viewer: (viewerId) => api.get(`/ranking/viewer/${viewerId}`),
  summary: () => api.get('/ranking/summary'),
  recentDonations: (params) => api.get('/ranking/recent-donations', { params }),
};

// ─── YouTube ────────────────────────────────────────────────
export const youtubeAPI = {
  auth: () => api.get('/youtube/auth'),
  disconnect: () => api.post('/youtube/disconnect'),
  startMonitor: () => api.post('/youtube/monitor/start'),
  stopMonitor: () => api.post('/youtube/monitor/stop'),
  monitorStatus: () => api.get('/youtube/monitor/status'),
  participants: () => api.get('/youtube/monitor/participants'),
  spenders: () => api.get('/youtube/monitor/spenders'),
};

// ─── Notifications ──────────────────────────────────────────
export const notificationAPI = {
  recent: (params) => api.get('/notifications/recent', { params }),
  activeSpenders: () => api.get('/notifications/active-spenders'),
};

// ─── Data Import ────────────────────────────────────────────
export const importAPI = {
  funnation: (store_slug) => api.post('/import/funnation', { store_slug }),
  toonation: () => api.post('/import/toonation'),
  status: () => api.get('/import/status'),
};

export default api;
